import { Component, OnChanges, Input, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { PIDService } from '../../services/pid.service';
import { NotificationService } from '../../services/notification.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

interface Food {
    value: string;
    viewValue: string;
}

@Component({
    selector: 'pid-transfer-modal',
    templateUrl: './pid-transfer.component.html',
    styleUrls: ['./pid-transfer.component.scss']
})
export class PIDTransferComponent implements OnChanges {
    @Input() show;
    @Input() steps;
    @Input() pids;
    @Input() modal;
    @Input() doUpdateFilter;

    rows = [];
    editable = true;
    transferRow = [{ 'type': 'dummy', 'email': 'dummy' }];
    transferEmail = null;
    transferType = "readonly";
    pid = null;
    transferEmailForm = null;

    constructor(private _pidService: PIDService, public translate: TranslateService, private _notification: NotificationService) { }

    ngOnInit() {
        this.transferEmailForm = new FormGroup({
            transferEmail: new FormControl(this.transferEmail, [
                Validators.required,
                Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,10}$"),
            ]),
            transferType: new FormControl('readonly', [
                Validators.required,
            ]),
        });
    }

    formatRow(s) {
        return {
            'name': s.name || (s.firstname || '') + ' ' + (s.lastname || ''),
            email: s.email,
            transferSubType: s.transferSubType,
            date: s.initAt || s.completedAt
        };
    }

    infoicon() {
        return '<i class="material-icons ic-info">info</i>';
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.hasOwnProperty('show') && changes.show.currentValue && this.modal.pid) {
            //this.transferEmail = '';
            this.transferEmailForm.get('transferEmail').setValue('');
            if (this.modal.pid) {
                this.editable = true;
                if (this.modal.pid.sharedWith && this.modal.pid.sharedWith.length) {
                    //this.transferType = "shared";
                    this.transferEmailForm.get('transferType').setValue('shared');
                } else {
                    //this.transferType = "readonly";
                    this.transferEmailForm.get('transferType').setValue('readonly');
                }
                if ((!this.modal.pid.sharedWith || !this.modal.pid.sharedWith.length) && !this.modal.pid?.transferTo?.details?.length) {
                    this.editable = true;
                } else {
                    if (this.modal.pid?.transferTo?.details?.length && !this.modal.pid?.copy) {
                        1;
                    } else {
                        this.editable = false;
                    }
                }

                this.rows = [];
                let emails = [];
                for (let s of this.modal.pid.sharedWith || []) {
                    emails.push(s.email);
                    //let row = this.formatRow(s)
                    //row['type'] = 'shared';
                    //this.rows.push(row);
                    this.editable = true;
                }

                for (let s of (this.modal.pid?.transferTo?.details || [])) {
                    if (emails.indexOf(s.email) == -1) {
                        if (s.transferType == 'shared') {
                            let row = this.formatRow(s);
                            row['type'] = 'shared_pending';
                            this.editable = true;
                            this.rows.push(row);
                        } else {
                            let row = this.formatRow(s);
                            if (s.pending) {
                                row['type'] = 'readonly_pending';
                                this.editable = true;
                            } else {
                                row['type'] = 'readonly';
                            }
                            this.rows.push(row);
                        }
                    } else {
                        let row = this.formatRow(s);
                        row['type'] = 'shared';
                        this.rows.push(row);
                        this.editable = true;
                    }
                }
            }

            if (this.modal.pid.copy) this.editable = false;
            //console.log(this.rows);
        }
    }

    initTransferPID(transferEmail, transferType) {
        //console.log("initransfer pid", transferEmail, transferType, this.modal.pid._id, this.transferEmailForm.get('transferType').value);
        if (transferEmail || (transferType == 'unshare' || (transferType == 'unreadonly'))) {
            let transferSubType = '';
            if (transferType == 'shared_ro') {
                transferType = 'shared';
                transferSubType = 'ro';
            }
            //console.log("init transfer. type is", this.modal.pid.name, transferType, transferSubType, 'this.doUpdateFilter', this.doUpdateFilter);
            this._pidService.initTransfer(this.modal.pid._id, transferEmail, transferType, transferSubType).subscribe(
                (pid: any) => {
                    console.log("init transfer", pid);
                    this.modal.pid = pid;
                    this.modal.transferPID = false;
                    if (transferType == 'unshare') {
                        this._notification.info('MESSAGE.SHARING_STOPPED');
                    } else if (transferType == 'unreadonly') {
                        this._notification.info('MESSAGE.TRANSFER_STOPPED');
                    } else {
                        this._notification.info('MESSAGE.TRANSFER_INITIATED');
                    }
                    //this.reload();

                    const found = _.find(this.pids.all, e => {
                        return e._id == pid._id;
                    });
                    if (found) {
                        _.merge(found, pid);
                    }

                    if (this.doUpdateFilter) this.doUpdateFilter();
                },
                err => {
                    console.error(err);
                    if (err.status == 403) {
                        this._notification.errorServer('MESSAGE.ERROR.FORBIDDEN');
                    } else {
                        this._notification.errorServer(err.error);
                    }
                }
            );
        }
    }

}
